(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hp-email-capture"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-hp-email] form').forEach(function (form) {
      form.addEventListener('submit', function () {
        var section = form.closest('[data-hp-email]');
        var tag = form.querySelector('input[name="contact[tags]"]');
        var placement = tag ? tag.value.split(',').pop() || '' : '';
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'hp_email_submit', placement: placement });
        document.dispatchEvent(new CustomEvent('hp_email_submit', { detail: { placement: placement } }));
        if (section) section.setAttribute('data-submitted', 'true');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hp-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function emit(name, payload) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, payload || {}));
      document.dispatchEvent(new CustomEvent(name, { detail: payload || {} }));
    }

    document.querySelectorAll('.hp-hero [data-hp-event]').forEach(function (el) {
      el.addEventListener('click', function () {
        emit(el.getAttribute('data-hp-event'), { text: (el.textContent || '').trim() });
      });
    });

    document.querySelectorAll('[data-hp-hero-video]').forEach(function (wrap) {
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (reduce.matches) {
        // Removing the element fires disconnectedCallback, which disconnects the
        // native video-player IntersectionObserver so the file is never fetched.
        var player = wrap.querySelector('video-player');
        if (player) player.remove();
        return;
      }
      // Fade in only once the native player has actually inserted a <video>.
      var obs = new MutationObserver(function () {
        if (wrap.querySelector('video')) {
          wrap.classList.add('is-ready');
          obs.disconnect();
        }
      });
      obs.observe(wrap, { childList: true, subtree: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hp-product-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function emit(name, payload) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, payload || {}));
      document.dispatchEvent(new CustomEvent(name, { detail: payload || {} }));
    }

    document.querySelectorAll('[data-hp-tabs]').forEach(function (root) {
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
      if (!tabs.length) return;

      function select(index, focus) {
        tabs.forEach(function (tab, i) {
          var on = i === index;
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.setAttribute('tabindex', on ? '0' : '-1');
          // The theme's own button classes carry the styling: filled when selected,
          // outline when not. No custom colours anywhere.
          tab.classList.toggle('button-outline', !on);
          var panel = root.querySelector('#' + tab.getAttribute('aria-controls'));
          if (panel) {
            if (on) {
              panel.removeAttribute('hidden');
            } else {
              panel.setAttribute('hidden', '');
            }
          }
        });
        if (focus) tabs[index].focus();
        emit('hp_tab_switch', { tab: (tabs[index].textContent || '').trim() });
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () {
          select(i, false);
        });
        tab.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowRight') next = (i + 1) % tabs.length;
          else if (e.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
          else if (e.key === 'Home') next = 0;
          else if (e.key === 'End') next = tabs.length - 1;
          if (next !== null) {
            e.preventDefault();
            select(next, true);
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
